import { z } from "zod";
import { timestampSchema } from "./timestamp";

/**
 * Przeznaczenie wypłaty — deklaracja rodziny przy payout, na co idą pieniądze.
 * Edukacja finansowa: buduje świadomość wydawania, liczone w podsumowaniach.
 */
export const payoutPurposeSchema = z.enum(["goal", "spending", "saving"]);
export type PayoutPurpose = z.infer<typeof payoutPurposeSchema>;

export const payoutSchema = z.object({
  id: z.string(),
  userId: z.string(),
  amountMinor: z.number().int().positive(),
  paidBy: z.string(),
  /**
   * UID dorosłego, którego "tab" z dzieckiem jest spłacany.
   * Domyślnie = paidBy (dorosły płaci ze swojego rachunku).
   * Optional dla backward-compat — stare payouts bez fundedBy traktowane
   * jako "ogólny" payout (dla user-facing UI: zaliczone na wszystkich).
   */
  fundedBy: z.string().optional(),
  paidAt: timestampSchema,
  note: z.string().max(200).optional(),
  purpose: payoutPurposeSchema.optional(),
  // Cel (individual_money), na który poszła wypłata — gdy purpose === "goal".
  relatedGoalId: z.string().optional(),
});
export type Payout = z.infer<typeof payoutSchema>;
